import {
  FormControlLabel as FormControlLabelMui,
  FormControlLabelProps as FormControlLabelPropsMui,
} from '@mui/material';

export type FormControlLabelProps = FormControlLabelPropsMui;

export function FormControlLabel({ ...rest }: FormControlLabelProps) {
  return <FormControlLabelMui {...rest} />;
}
